<app-loading></app-loading>
<div class="page-wraper">
  <!-- header -->
  <app-header1 [data]="profile"></app-header1>
  <!-- header END -->
  <app-page-banner [data]="page_banner"></app-page-banner>
  <app-social-bar></app-social-bar>

  <div class="content-body">
    <div class="content-body-inner">

      <!-- About Info -->
      <div class="section-full">
        <div class="section-head">
          <h2 class="title text-uppercase">How Can I <span class="text-gradient">Help You</span>?</h2>
        </div>
        <div class="contact-form">
          <form class="dzForm dezPlaceAni" [formGroup]="contactForm" method="post" (ngSubmit)="onSubmit()">
            <div class="dzFormMsg"></div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <i class="las la-user text-gradient"></i>
                  <label>Your Name</label>
                  <input [formControl]="name" required class="form-control">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <i class="las la-envelope-open text-gradient"></i>
                  <label>Your Email Address</label>
                  <input [formControl]="email" required class="form-control">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <i class="las la-phone-volume text-gradient"></i>
                  <label>Phone Number</label>
                  <input [formControl]="phone" required class="form-control">
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <i class="las la-file-alt text-gradient"></i>
                  <label>Subject</label>
                  <input [formControl]="subject" required class="form-control">
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <i class="las la-envelope-open text-gradient"></i>
                  <label>Your Message</label>
                  <textarea [formControl]="message" rows="4" class="form-control" required></textarea>
                  <textarea [formControl]="honeypot" class="hidden form-control" type="text"></textarea>
                  <div [ngClass]="!submitted? 'hidden' : 'visible'" class="center-text">
                    <span class="text-gradient">{{responseMessage}}</span>
                  </div>
                </div>
                <div class="col-md-12">
                  <button [disabled]="isLoading" class="site-button button-gradient button-md radius-no"
                    type="submit">Send message</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- Contact Info -->
      <div class="section-full content-inner">
        <app-icon-box></app-icon-box>
      </div>

      <!-- Map -->
      <div class="section-full maps">
        <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14445.871196953145!2d75.8417313!3d25.153677599999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1580295328844!5m2!1sen!2sin" style="border:0; width: 100%;" allowfullscreen=""></iframe> -->
        <div style="width: 100%"><iframe width="100%" height="600" frameborder="0" scrolling="no" marginheight="0"
            marginwidth="0"
            src="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Farvagny+()&amp;t=&amp;z=11&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"></iframe><a
            href="https://www.maps.ie/route-planner.htm">Google Route Planner</a></div>
      </div>

    </div>
  </div>
</div>
